import React from 'react';

const EventCard = ({ event }) => {
  const categoryLabel = event.category || (event.categories && event.categories.join(', '));

  return (
    <div className="bg-card shadow-soft rounded-2xl p-4 text-white hover:scale-105 transform transition duration-300">
    <h3 className="text-xl font-semibold">{event.title}</h3>
    <p className="text-sm text-gray-300 mb-2">{event.year}</p>
    <p className="text-gray-200 text-sm mb-3">{event.description}</p>
    {event.categories && (
      <div className="flex flex-wrap gap-2 mt-2">
        {event.categories.map((cat, i) => (
          <span key={i} className="bg-accent/10 text-accent text-xs px-2 py-1 rounded-full">
            {cat}
          </span>
        ))}
      </div>
    )}
  </div>
  
  );
};

export default EventCard;